import {List, Modal, Select} from "antd";
import React, {useEffect, useState} from "react";
import {useFetch} from "../../../../hooks/useFetch";
import {useStore} from "../../../../hooks/useStore";
import {CustomButton} from "../../../_defaultComponents/CustomButton/CustomButton";

const OrderTransferCenterModal = ({isOpen, onClose, nextTransferCenters, onSave}) => {
    const stores = useStore();
    const [selectedCenters, setSelectedCenters] = useState([]);
    const [orderTransferCenterStates, setOrderTransferCenterStates] = useState({});
    const mockData = [1, 2, 3];

    const [transferCentersLoading, transferCenters] = useFetch({
        fetchFn: () =>
            stores.transferStore.transferCenters({
                type: "distributionPoint",
                owner: "vigo"
            }),
        loading: true,
        dependencies: []
    });

    const handleChange = (value, index) => {
        const selectedCenter = transferCenters?.result?.find(c => c._id === value);

        if (!selectedCenter) return;

        setOrderTransferCenterStates(prev => ({
            ...prev,
            [index]: value
        }));

        setSelectedCenters(prev => {
            const newCenters = [...prev];
            const existingIndex = newCenters.findIndex(c => c.order === index + 1);

            const centerData = {
                id: selectedCenter._id,
                to: selectedCenter._id,
                type: "midMile",
                name: selectedCenter.name,
                order: index + 1
            };

            if (existingIndex !== -1) {
                newCenters[existingIndex] = centerData;
            } else {
                newCenters.push(centerData);
            }

            return newCenters;
        });
    };

    const handleSave = () => {
        onSave(selectedCenters);
        onClose();
    };

    const handleCancel = () => {
        setOrderTransferCenterStates({});
        onClose();
    };

    useEffect(() => {
        if (isOpen && nextTransferCenters?.length > 0) {
            setSelectedCenters(nextTransferCenters);
            const states = {};
            nextTransferCenters.forEach(center => {
                states[center.order - 1] = center.id;
            });
            setOrderTransferCenterStates(states);
        } else {
            setSelectedCenters([]);
            setOrderTransferCenterStates({});
        }
    }, [isOpen, nextTransferCenters]);

    return (
        <Modal
            title="Dağıtım Noktalarını Sırala"
            visible={isOpen}
            onOk={handleSave}
            onCancel={handleCancel}
            footer={[
                <CustomButton key="cancel" onClick={handleCancel}>
                    İptal
                </CustomButton>,
                <CustomButton key="save" type="primary" onClick={handleSave}>
                    Kaydet
                </CustomButton>
            ]}
        >
            <div style={{display: "flex", flexDirection: "column", gap: "16px"}}>
                {mockData.map((item, index) => (
                    <div key={index}>
                        <h2>{item}. Depo</h2>
                        <Select
                            style={{width: "100%"}}
                            value={orderTransferCenterStates[index]}
                            onChange={value => handleChange(value, index)}
                        >
                            {transferCenters?.result?.map(center => (
                                <Select.Option key={center._id} value={center._id}>
                                    {center.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                ))}
            </div>

            <List
                style={{marginTop: "16px"}}
                dataSource={nextTransferCenters.sort((a, b) => a.order - b.order)}
                renderItem={center => (
                    <List.Item>
                        {center.order}. {center.name}
                    </List.Item>
                )}
            />
        </Modal>
    );
};

export default OrderTransferCenterModal;
